import React from "react";
import { observer } from "mobx-react";
import { CreditTierUpdateStore } from "../../store";
import { CreditTierUpdateForm } from "./CreditTierUpdateForm";
import { ErrorDialog, ConfirmCancelDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";
import { OutdatedAfterSaveNotice } from "../../../../common/controls/forms/OutdatedAfterSaveNotice";

export type CreditTierUpdateProps = {
  creditTierUpdateStore: CreditTierUpdateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const CreditTierUpdate: React.FC<CreditTierUpdateProps> = observer(
  ({ creditTierUpdateStore, showToolbox = true, showSaveFooter }) => {
    return (
      <>
        <SavingOverlay open={creditTierUpdateStore.isSaving} />
        <OutdatedAfterSaveNotice
          open={creditTierUpdateStore.savedButOutdated}
          onReload={() => creditTierUpdateStore.reloadCreditTier()}
          reloadDisabled={creditTierUpdateStore.isProcessing}
        />
        <CreditTierUpdateForm
          creditTierUpdateStore={creditTierUpdateStore}
          name_esError={creditTierUpdateStore.errors.name_es?.message}
          onName_esChange={(value: string) => {
            creditTierUpdateStore.setName_esValue(value);
          }}
          name_es={creditTierUpdateStore.entityValues.name_es}
          name_enError={creditTierUpdateStore.errors.name_en?.message}
          onName_enChange={(value: string) => {
            creditTierUpdateStore.setName_enValue(value);
          }}
          name_en={creditTierUpdateStore.entityValues.name_en}
          name_ptError={creditTierUpdateStore.errors.name_pt?.message}
          onName_ptChange={(value: string) => {
            creditTierUpdateStore.setName_ptValue(value);
          }}
          name_pt={creditTierUpdateStore.entityValues.name_pt}
          monthlyCreditsError={
            creditTierUpdateStore.errors.monthlyCredits?.message
          }
          onMonthlyCreditsChange={(value: number) => {
            creditTierUpdateStore.setMonthlyCreditsValue(value);
          }}
          monthlyCredits={creditTierUpdateStore.entityValues.monthlyCredits}
          pricePerCreditError={
            creditTierUpdateStore.errors.pricePerCredit?.message
          }
          onPricePerCreditChange={(value: number) => {
            creditTierUpdateStore.setPricePerCreditValue(value);
          }}
          pricePerCredit={creditTierUpdateStore.entityValues.pricePerCredit}
          pricePerExtraCreditError={
            creditTierUpdateStore.errors.pricePerExtraCredit?.message
          }
          onPricePerExtraCreditChange={(value: number) => {
            creditTierUpdateStore.setPricePerExtraCreditValue(value);
          }}
          pricePerExtraCredit={
            creditTierUpdateStore.entityValues.pricePerExtraCredit
          }
          description_esError={
            creditTierUpdateStore.errors.description_es?.message
          }
          onDescription_esChange={(value: string) => {
            creditTierUpdateStore.setDescription_esValue(value);
          }}
          description_es={creditTierUpdateStore.entityValues.description_es}
          description_enError={
            creditTierUpdateStore.errors.description_en?.message
          }
          onDescription_enChange={(value: string) => {
            creditTierUpdateStore.setDescription_enValue(value);
          }}
          description_en={creditTierUpdateStore.entityValues.description_en}
          description_ptError={
            creditTierUpdateStore.errors.description_pt?.message
          }
          onDescription_ptChange={(value: string) => {
            creditTierUpdateStore.setDescription_ptValue(value);
          }}
          description_pt={creditTierUpdateStore.entityValues.description_pt}
          showToolbox={showToolbox}
          showSaveFooter={showSaveFooter}
          saving={creditTierUpdateStore.saveDisabled}
          onSave={() => creditTierUpdateStore.saveCreditTier()}
          onCancel={() => creditTierUpdateStore.cancelCreditTier()}
        />
        <ErrorDialog
          open={creditTierUpdateStore.errorDialogOpened}
          title={creditTierUpdateStore.errorTitle}
          description={creditTierUpdateStore.errorDescription}
          onClose={() => creditTierUpdateStore.closeErrorDialog()}
        />
        <ConfirmCancelDialog
          open={creditTierUpdateStore.confirmDialogOpened}
          title={creditTierUpdateStore.confirmDialogTitle}
          description={creditTierUpdateStore.confirmDialogDescription}
          onConfirm={() => creditTierUpdateStore.executeConfirmedAction()}
          onCancel={() => creditTierUpdateStore.closeConfirmDialog()}
        />
      </>
    );
  }
);
